import $ from "jquery";
window.$ = window.jQuery = $;

require('inputmask/dist/jquery.inputmask');
require('resize-sensor/ResizeSensor');
require('sticky-sidebar/dist/jquery.sticky-sidebar.js');
import uiMask from 'angular-ui-mask';

import angular from "angular";
import fileUpload from "ng-file-upload";
import XMLHttpRequest from "../../modules/app/XMLHttpRequest";

angular.module('app',[fileUpload, XMLHttpRequest, uiMask]);

angular
    .module('app')
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('XMLHttpRequest');
    }])

require('../components/register-request-form/register-request-form');

window.$(function () {

    window.$("#tabs").tabs();

    window.$('#contact-link').on('click', function (event) {
        event.preventDefault();
        window.$('#go-to-connect-link').first().click();
    });

    window.$('.connect-link').on('click', function (event) {
        event.preventDefault();
        window.$('#go-to-register-link').first().click();
    })

    // window.$(".content__form-link--tab").on('click', function() {
    //     window.$('#tabs-1, #tabs-3, #tabs-4').css('display', 'none');
    //     window.$('#tabs-1, #tabs-3, #tabs-4').attr('aria-hidden', 'true');
    //     window.$('#tabs-2').css('display', '');
    //     window.$('#tabs-2').attr('aria-hidden', 'false');
    // });

    window.$('.sidebar__menu-item').on('click', function () {
        window.$(this).addClass('sidebar__menu-item--active').siblings().removeClass('sidebar__menu-item--active')
    });

    window.$('.sidebar__guide-menu-item').on('click', function () {
        window.$(this).addClass('sidebar__guide-menu-item--active').siblings().removeClass('sidebar__guide-menu-item--active')
    });

    window.$('#sidebar').stickySidebar({
        // containerSelector: '.main__sidebar',
        topSpacing: 20,
        resizeSensor: true,
        minWidth: 670
    })

    window.$('#toggleMenu').on('click', function () {
        window.$('.main__sidebar').toggleClass('main__sidebar--active');
        window.$('.help-modal--toggle').removeClass('help-modal--toggle-active');
        window.$('.header__menu-button--contacts').removeClass('header__menu-button--contacts-active');
    })

    window.$('.header__menu-button--contacts, .content__btn--mob').on('click', function () {
        window.$('.help-modal--toggle').toggleClass('help-modal--toggle-active');
        window.$('.header__menu-button--contacts').toggleClass('header__menu-button--contacts-active');
        window.$('.main__sidebar').removeClass('main__sidebar--active');
    })

    window.$('.sidebar__menu-link').on('click', function () {
        window.$('body,html').animate({scrollTop: 0}, 100);
        window.$('.main__sidebar').toggleClass('main__sidebar--active');
        window.$('.sidebar__guide-menu').removeClass('sidebar__guide-menu--active');
    })

    window.$('.sidebar__menu-item--guide').on('click', function () {
        window.$('.sidebar__guide-menu').addClass('sidebar__guide-menu--active');
    })

    window.$('#balanceList').on('click', function () {
        window.scroll(0, 354);
    })

    window.$('#authorizationList').on('click', function () {
        window.scroll(0, 866);
    })

    window.$('#bookingList').on('click', function () {
        window.scroll(0, 1170);
    })

    window.$('#returnList').on('click', function () {
        window.scroll(0, 2110);
    })

    window.$('#balanceListMobile').on('click', function () {
        window.scroll(0, 280);
    })

    window.$('#authorizationListMobile').on('click', function () {
        window.scroll(0, 960);
    })

    window.$('#bookingListMobile').on('click', function () {
        window.scroll(0, 1245);
    })

    window.$('#returnListMobile').on('click', function () {
        window.scroll(0, 2270);
    })

    window.$(window).on('scroll', function () {
        // console.log(window.$(window).scrollTop().toFixed(0));
        if (window.$(window).scrollTop().toFixed(0) <= 345) {
            window.$('.sidebar__guide-menu-item').removeClass('sidebar__guide-menu-item--active');
            window.$('#balanceList').addClass('sidebar__guide-menu-item--active');
        }
        if (window.$(window).scrollTop().toFixed(0) > 840 && window.$(window).scrollTop().toFixed(0) <= 866) {
            window.$('.sidebar__guide-menu-item').removeClass('sidebar__guide-menu-item--active');
            window.$('#authorizationList').addClass('sidebar__guide-menu-item--active');
        }
        if (window.$(window).scrollTop().toFixed(0) > 1132 && window.$(window).scrollTop().toFixed(0) <= 1170) {
            window.$('.sidebar__guide-menu-item').removeClass('sidebar__guide-menu-item--active');
            window.$('#bookingList').addClass('sidebar__guide-menu-item--active');
        }
        if (window.$(window).scrollTop().toFixed(0) > 2105) {
            window.$('.sidebar__guide-menu-item').removeClass('sidebar__guide-menu-item--active');
            window.$('#returnList').addClass('sidebar__guide-menu-item--active');
        }

        if (window.$(window).scrollTop().toFixed(0) <= 280) {
            window.$('.mobile-menu__item').removeClass('mobile-menu__item--active');
            window.$('#balanceListMobile').addClass('mobile-menu__item--active');
        }
        if (window.$(window).scrollTop().toFixed(0) > 930 && window.$(window).scrollTop().toFixed(0) <= 1000) {
            window.$('.mobile-menu__item').removeClass('mobile-menu__item--active');
            window.$('#authorizationListMobile').addClass('mobile-menu__item--active');
        }
        if (window.$(window).scrollTop().toFixed(0) > 1190 && window.$(window).scrollTop().toFixed(0) <= 1250) {
            window.$('.mobile-menu__item').removeClass('mobile-menu__item--active');
            window.$('#bookingListMobile').addClass('mobile-menu__item--active');
        }
        if (window.$(window).scrollTop().toFixed(0) > 2260) {
            window.$('.mobile-menu__item').removeClass('mobile-menu__item--active');
            window.$('#returnListMobile').addClass('mobile-menu__item--active');
        }
    })

});


// WEBPACK FOOTER //
// ./resources/assets/manual/js/manual.js